import { useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

// Keyboard shortcut for toggling column names on/off, mainly for developers.
// Shows the raw column key instead of the translated name (Ctrl/Cmd + Alt + T).
export const useShowColumnKeys = (): boolean => {
  const [showColumnKeys, setShowColumnKeys] = useState(false);

  useHotkeys(
    'meta+alt+t,ctrl+alt+t',
    () => {
      setShowColumnKeys((prev) => !prev);
    },
    // keyup mirrors the legacy Table shortcut, so holding the keys toggles only once
    { enableOnFormTags: true, enableOnContentEditable: true, keyup: true },
    []
  );

  return showColumnKeys;
};
